import { render } from "./authorize.vue?vue&type=template&id=213f1977&ts=true"
import script from "./authorize.vue?vue&type=script&lang=ts"
export * from "./authorize.vue?vue&type=script&lang=ts"

import "./authorize.vue?vue&type=style&index=0&id=213f1977&lang=scss"

import exportComponent from "/codebuild/output/src2155066187/src/reference-ui/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__